// extracted by mini-css-extract-plugin
export default {"debug":"Reminder_debug__PHb8B","reminderSegment":"Reminder_reminderSegment__3yepW","remove":"Reminder_remove__XfBX2","text":"Reminder_text__THRZT"};